import { Avatar, Card, List, Spin } from "antd";
import { useEffect, useState } from "react";

import discord_channels from "../../../types/discord_channels";
/* eslint-disable import/extensions */
import { MostActiveMembersRpc } from "../../lib/discordTypes";
import { getSupaClient } from "../../lib/supabase";
import { useEndTime, useStartTime } from "../DateContext/DateContext";
import UserListItem from "../UserListItem/UserListItem";
/* eslint-disable import/extensions */
import useMostActiveMembers from "./useMostActiveMembers";

/**
 * DiscordMostActiveMembersCard props
 * guildId: Discord guild id
 * channelId: the channel id (optional)
 */
interface Props {
  guildId: string | null;
  channelId?: string;
}

/**
 * A component that shows a list of the 5 most active Discord members over a period of time
 * @param props @see Props
 *
 */
export default function DiscordMostActiveMembersCard(props: Props) {
  const { guildId, channelId } = props;
  const { startTime, setStartTime } = useStartTime();
  const { endTime, setEndTime } = useEndTime();
  const [channelName, setChannelName] = useState<string>("");

  const supabase = getSupaClient();

  const loadChannelName = async () => {
    if (channelId) {
      const { data, error } = await supabase
        .from<discord_channels>("discord_channels")
        .select("name")
        .filter("discord_id", "eq", channelId);
      if (error) console.log("Error in loadChannelName:", error);
      setChannelName(data ? data[0].name : "");
    } else {
      setChannelName("");
    }
  };

  useEffect(() => {
    loadChannelName();
  }, [channelId]);

  const { data: mostActiveMembers, isLoading: loading } = useMostActiveMembers(
    startTime,
    endTime,
    guildId,
    channelId
  );

  return (
    <Card
      style={{ marginBottom: 40 }}
      title={
        channelName
          ? `Most active members in #${channelName}`
          : "Most active members"
      }
      bordered={false}
      extra={[]}
    >
      <Spin spinning={loading}>
        <List
          dataSource={mostActiveMembers || undefined}
          renderItem={(item: MostActiveMembersRpc) => (
            <UserListItem user={item} />
          )}
        />
      </Spin>
    </Card>
  );
}
